import React, { useMemo } from "react";
import I18nKey from "../../../src/models/i18n/keys";
import { GameNotificationBlock, GameNotificationBlockType } from "../../../src/server/models/game/modules/notifications/blocks";
import NotificationGame from "./notificationgame";
import NotificationUser from "./notificationuser";
import { Trans, useTranslation } from "react-i18next";
import NotificationBot from "./notificationbot";
import NotificationSpecialSeat from "./notificationspecialseat";

type Props = {
    translationKey: I18nKey;
    blocks: Record<string, GameNotificationBlock>;
}

const componentMap = {
    [GameNotificationBlockType.Game]: NotificationGame,
    [GameNotificationBlockType.User]: NotificationUser,
    [GameNotificationBlockType.Bot]: NotificationBot,
    [GameNotificationBlockType.SpecialSeat]: NotificationSpecialSeat,
}

export default function NotificationTranslation(
    {
        translationKey,
        blocks,
    }: Props,
): React.ReactNode {
    const { t } = useTranslation();

    // map blocks to their corresponding components
    const components = useMemo(
        () => Object.fromEntries(
            Object
                .entries(blocks)
                .map(
                    ([key, block]) => [
                        key,
                        React.createElement(
                            componentMap[block.type.toString()],
                            {
                                block,
                            },
                        ),
                    ],
                ),
        ),
        [blocks],
    );

    // this will transform something like {{game}} to <game />
    // which will then render it as a react component. this will
    // maintain compatibility with the server side implementation
    // so we can share strings
    const text = t(translationKey)
        .replaceAll(
            /\{\{(.*?)\}\}/g,
            (_, token) => `<${token} />`,
        );

    return <Trans components={components}>
        {text}
    </Trans>;
}
